(() => {
  const EVENT_PREFIX = "wynch:stories-promo";

  const emit = (root, name, trigger) => {
    const active = root.querySelector("[data-wynch-promo-slide]:not([hidden])");
    root.dispatchEvent(new CustomEvent(`${EVENT_PREFIX}-${name}`, {
      bubbles: true,
      detail: {
        sectionId: root.dataset.sectionId || null,
        slideIndex: active ? Number(active.dataset.slideIndex) : null,
        trigger,
      },
    }));
  };

  const mountPromo = (root) => {
    if (!(root instanceof HTMLElement) || root.dataset.promoMounted === "true") return;

    const slides = Array.from(root.querySelectorAll("[data-wynch-promo-slide]"));
    if (slides.length === 0) return;

    const dots = Array.from(root.querySelectorAll("[data-wynch-promo-dot]"));
    const current = root.querySelector("[data-wynch-promo-current]");
    const eyebrow = root.querySelector("[data-wynch-promo-eyebrow]");
    const previous = root.querySelector("[data-wynch-promo-previous]");
    const next = root.querySelector("[data-wynch-promo-next]");
    let activeIndex = 0;

    const show = (nextIndex, trigger) => {
      activeIndex = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, index) => {
        slide.hidden = index !== activeIndex;
      });
      dots.forEach((dot, index) => {
        dot.classList.toggle("is-active", index === activeIndex);
      });
      if (current) current.textContent = String(activeIndex + 1);
      if (eyebrow) eyebrow.textContent = slides[activeIndex].dataset.promoEyebrow || "";
      emit(root, "change", trigger);
    };

    previous?.addEventListener("click", () => show(activeIndex - 1, "previous"));
    next?.addEventListener("click", () => show(activeIndex + 1, "next"));
    root.querySelectorAll("[data-wynch-promo-cta]").forEach((cta) => {
      cta.addEventListener("click", () => emit(root, "click", "cta"));
    });

    root.dataset.promoMounted = "true";
    emit(root, "view", "mount");
  };

  const mountAll = (scope = document) => {
    scope.querySelectorAll("[data-wynch-stories-promo]").forEach(mountPromo);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => mountAll(), { once: true });
  } else {
    mountAll();
  }

  document.addEventListener("shopify:section:load", (event) => mountAll(event.target));
})();
